import { BrandModel } from '@water-web/repository';

import { persistentKVStore } from '../persistence';

// once we store the pixel ids in the database, we can deprecate this function
export const getBrandPixelId = (brand: BrandModel | null, debug = false): string | null => {
  if (debug && typeof window !== 'undefined') {
    const storedDebugPixelId = persistentKVStore.getItem('debug_facebook_pixel_id');
    if (storedDebugPixelId) {
      return storedDebugPixelId;
    }
  }

  if (!brand) {
    return null;
  }

  if (brand.getMetaPixelId()) {
    return brand.getMetaPixelId();
  }

  return null;
};
